if(!customElements.get('component-tabs-collections')) {
  class ComponentTabsCollections extends HTMLElement {
    constructor() {
      super();

      
      this.tabButtons = this.querySelectorAll('.tab-btn');

      if(this.tabButtons.length > 0){

        this.currentSelection = this.tabButtons[0];
        this.slides = this.querySelectorAll('.keen-slider-slide');
        
        this.tabButtons.forEach(btn =>{
          btn.addEventListener('click', () => {
            this.currentSelection.classList.remove('selected');
            this.currentSelection = btn;
            this.currentSelection.classList.add('selected');
            var dataSelector = this.currentSelection.dataset.cardClass;
            this.slides.forEach(slide => {
              if(slide.classList.contains(dataSelector)){
                slide.classList.remove('hide');
              } else {
                slide.classList.add('hide');
              }

            })

            window.dispatchEvent(new Event('forceResize'));
           


          });
        });
        
      }

      
    }
    
   
    
  }
  customElements.define('component-tabs-collections', ComponentTabsCollections);
}